const config = {
  development: {
    sitelocked: false,
  },
  staging: {
    sitelocked: false,
  },
  uat: {
    sitelocked: false,
  },
  production: {
    sitelocked: false,
  },
};

export default config;
